import * as numeral from 'numeral';

export class CurrencyValueConverter {
    toView(value) {
        if (value === null || value === undefined || value === "") {
            return value;
        }
        return numeral(value).format('($0,0)');
    }
    fromView(value) {
        if (value === null || value === undefined || value === "") {
            return undefined;
        }
        return numeral(value).value();  
    }
}